import { PropertiesStore } from '@hortplus/properties-react';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Modal } from 'react-bootstrap';
import LoadingOverlay from '../../LoadingOverlay';
import ConfirmationModal from '../../helpers/ConfirmationModal';
import { useStores } from '../../stores/useStores';
import SetupTrapsForm from '../SetupTrapsForm';
import { noUpdates, submitForm } from './utils';

const SetupTrapsModal = (props) => {
  const { traplogStore } = useStores();
  const [show, setShow] = useState(false);

  const hide = () => {
    setShow(false);
  };

  // Remove the 'charged input' section from the conrimation modal body text
  // if the charged input has been disabled.
  const confirmationModalBodyText = React.useMemo(
    () =>
      `This will change the setup date ${
        props.chargedInput ? 'and charged date' : ''
      } for every trap within the selected production sites for the current season.`,
    [props.chargedInput]
  );

  return (
    <Fragment>
      <span onClick={() => setShow(true)}>{props.children}</span>
      <Modal backdrop='static' show={show} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>Seasonal Trap Setup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnBlur={false}
            validateOnChange={false}
            initialValues={{
              traps: []
            }}
            validate={(values) => {
              const errors = {};
              if (values.traps?.length === 0) {
                errors.traps = 'At least one trap must be selected.';
              }
              if (noUpdates({ ...values }))
                errors.no_changes = 'No updates to submit.';
              return errors;
            }}
            onSubmit={(values, actions) => {
              submitForm(values, actions, traplogStore, props.propertiesStore);
            }}
          >
            {(fProps) => (
              <Fragment>
                <SetupTrapsForm {...fProps} chargedInput={props.chargedInput} />
                {fProps.isSubmitting ? <LoadingOverlay /> : null}
                <ConfirmationModal
                  title='Warning'
                  titleProps={{
                    className: 'text-white'
                  }}
                  headerProps={{
                    className: 'bg-secondary'
                  }}
                  bodyText={confirmationModalBodyText}
                  confirmAction={() => {
                    fProps.handleSubmit();
                  }}
                  showAction={() => {
                    fProps.validateForm();
                  }}
                  showModal={!noUpdates({ ...fProps.values })}
                  showButton={{
                    children: 'Submit',
                    props: {
                      varient: 'primary',
                      type: 'button'
                    }
                  }}
                  confirmButton={{
                    props: { variant: 'primary' }
                  }}
                />
                <div className='text-danger' style={{ fontSize: '90%' }}>
                  {fProps.errors.no_changes}
                </div>
              </Fragment>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

SetupTrapsModal.propTypes = {
  propertiesStore: PropTypes.instanceOf(PropertiesStore).isRequired,
  chargedInput: PropTypes.bool.isRequired
};

export default observer(SetupTrapsModal);
